import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MeasurementResultService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllMeasurementResults(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.MeasurementResult,
      queryString: `page=${page}&size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdMeasurementResult(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.MeasurementResult,
    }, id);
    return await firstValueFrom(observable);
  }

  async getByKindMeasurementResult(kindId, referenceId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.MeasurementResult,
      queryString: `kindId=${kindId}&referenceId=${referenceId}`,
      action: "get-by-kind"
    });
    return await firstValueFrom(observable);
  }

  async addMeasurementResult(body) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.MeasurementResult
    }, body);
    return await firstValueFrom(observable);
  }

  async updateMeasurementResult(body) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.MeasurementResult
    }, body);
    return await firstValueFrom(observable);
  }

  async downloadMeasurementFile(measurementResultId: number, fileName: string, referenceDevices: any[], downloadFileName: string, companyInfo: any, deviceInfo: any) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.MeasurementResult,
      action: "downloadMeasurementFile",
    },
      {
        downloadFileName: downloadFileName,
        measurementResultId: measurementResultId,
        fileName: fileName,
        referenceDevices: referenceDevices,
        companyInfo: companyInfo,
        deviceInfo: deviceInfo
      }, 'blob');
    return await firstValueFrom(observable);
  }
}
